import { updateKeyInStore } from 'App';
import { updateKey, UsTrustStateValues } from '../slice';

export const uploadFields: IBaseField<keyof UsTrustStateValues>[] = [
  {
    name: 'pleaseUploadTrustFinancial',
    label: 'Please upload Trust Financial',
    subLabel: () => (
      <p>
        If a US trust and estate form is already filled, please attach sch K-1
      </p>
    ),
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];
